module.exports = __webpack_public_path__ + "img/info_09_ui.e2780f19.png";